var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scroll > 400)?_c('v-btn',{key:"1",attrs:{"fab":"","fixed":"","right":"","bottom":"","color":"gray"},on:{"click":_vm.scrollUp}},[_c('v-icon',[_vm._v("arrow_upward")])],1):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }